module.exports = __webpack_public_path__ + "static/media/menu-card-1.73d1c9f6.jpg";